import { TFunction } from "i18next";

export const formatBytes = (t: TFunction, bytes?: number): string => {
    if (bytes === undefined) {
        return '';
    }
    let unit = 'BYTES';
    let size = 0;
    if (!bytes || bytes === 0) {
        return t(`FILE_SIZE.${unit}`, [ size ]);
    }
    const k = 1024;
    const sizes = [ 'BYTES', 'KILOBYTES', 'MEGABYTES', 'GIGABYTES' ];
    const decimals = [ 0, 0, 1, 2 ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    size = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals[i]));
    unit = sizes[i];
    return t(`FILE_SIZE.${unit}`, [ size ]);
};